"use strict";
exports.__esModule = true;
exports.IsInternalLink = function (url) {
    return !url.startsWith("http") && !url.startsWith("mailto");
};
exports["default"] = exports.IsInternalLink;
